// extracted by mini-css-extract-plugin
module.exports = {"header":"BasicHeaderView_header__2zZ5W","rightSide":"BasicHeaderView_rightSide__treRT"};